import React from 'react'
import AsyncSelect from 'react-select/async'
import { FormItem, FormItemProps } from './FormItem'
import { IField, getRequiredError } from './FieldValidation'
import { Option } from './Options'
import { selectStyles } from './SelectField'
import { ErrorText } from './ErrorText'

export interface AddressOption extends Option<string> {
}

export interface AddressPickerProps extends FormItemProps {
    id: string
    onChange: { (value: AddressOption): any }
    value: AddressOption
    required?: boolean
    requiredMessage?: string
    disabled?: boolean
    australianAddressesOnly?: boolean
}

export interface AddressPickerState {
    errorText?: string
}

declare var google: any

export class AddressPicker extends React.Component<AddressPickerProps, AddressPickerState> implements IField {
  input: React.RefObject<any> = React.createRef()
  service: any

  constructor(props?: AddressPickerProps, context?: any) {
    super(props, context)

    this.state = {
    }

    this.service = new google.maps.places.AutocompleteService()
  }

  componentDidUpdate(prevProps: AddressPickerProps, prevState: AddressPickerState) {
    if (this.props.value != prevProps.value) {
      if (this.state.errorText) {
        this.validate(() => { })
      }
    }
  }

  load = (input: string, callback: ((options: AddressOption[]) => void)) => {
    if (!input.length) {
      return callback([])
    }

    this.service.getPlacePredictions({ input: input, types: ['address'], componentRestrictions: this.props.australianAddressesOnly ? { 'country': ['AU'] } : null }, (d: any, s: any) => {
      let data: AddressOption[] = []
      for (let i in d) {
        data.push({
          value: d[i].place_id,
          label: d[i].description,
        })
      }
      callback(data)
    })
  }

  render() {
    return <FormItem {...this.props} inputId={this.props.id} >
      <AsyncSelect styles={selectStyles(true, this.state.errorText ? true : false)}
        id={this.props.id}
        placeholder="Search..."
        ref={this.input}
        value={this.props.value}
        isDisabled={this.props.disabled}
        isClearable={true}
        onChange={(v: AddressOption) => this.props.onChange(v)}
        loadOptions={this.load}
      />
      <ErrorText text={this.state.errorText} />
    </FormItem>
  }

  focus() {
    if (this.input.current) {
      const selectElement = this.input.current as any
      if (selectElement && selectElement.focus) {
        selectElement.focus()
      }
    }
  }

  getErrorText(): string {
    if (this.props.required === true) {
      if (!this.props.value?.value) {
        return getRequiredError(this.props)
      }
    }
    return null
  }

  validate(callback: { (res: boolean): any }, focus?: boolean) {
    const errorText = this.getErrorText()
    this.setError(errorText, () => {
      if (this.props.errorMessage || errorText) {
        if (focus === true) {
          this.focus()
        }
      }
      callback && callback((this.props.errorMessage || errorText) ? false : true)
    })
  }

  setError(errorText?: string, callback?: { (): any }) {
    this.setState({ errorText }, callback)
  }
}
